// src/lib/mediaUrl.ts
// Resolve a user/media URL into something an <img> can actually load.
//
// The backend stores uploaded files (e.g. profile pictures) and returns their
// URL as a RELATIVE path like "/api/files/profile_xxx.png". But the API is
// served from a DIFFERENT origin than the web app — `localhost:3500` vs `:3000`
// in dev, and `api.nexilink.se` vs `nexilink.se` in prod. A relative `src` would
// resolve against the web-app origin and 404. External/absolute URLs (Google
// OAuth avatars, data:/blob: URIs) are already loadable and returned untouched.
import CONFIG from './config';

const API_ORIGIN = `${CONFIG.API_BASE_URL}${CONFIG.API_AUTH_PORT}`;

export const resolveMediaUrl = (url?: string | null): string | undefined => {
    if (!url) return undefined;
    if (/^(https?:|data:|blob:)/i.test(url)) return url; // already absolute
    return `${API_ORIGIN}${url.startsWith('/') ? '' : '/'}${url}`;
};
